import React from "react";
import { Breadcrumb } from "antd";
import ServiceTabs from "./ServiceTabs";
import { useState } from "react";

const Service = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Service</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Service" }, { title: breadcrumb }]}
        />
      </div>
      <ServiceTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default Service;
